export const DESKTOP = 1024;
export const TABLET = 834;
export const MOBILE = 550;
export const MOBILE_EXTENDED = 550;

export const WIDTHS_MOBILE_IPHONE_14_PRO = 430;
